import RemboMark from "./RemboMark";
import "./css/rembo_logo.css";

const MARK_SIZE = { sm: 22, md: 32, lg: 44 };

// Brand lockup: the RL monogram plus the "RemboList." wordmark (Outfit, ink
// text, rust full stop). `theme="dark"` is the light-on-dark variant used on
// the indigo auth panel, the landing footer and the admin sidebar.
export default function RemboLogo({ variant = "full", theme = "light", size = "md", className }) {
  const markSize = MARK_SIZE[size] || MARK_SIZE.md;

  if (variant === "mark") {
    return (
      <span className={`rl-logo rl-logo--mark${className ? ` ${className}` : ""}`}>
        <RemboMark size={markSize} variant="solid" title="RemboList" />
      </span>
    );
  }

  return (
    <span
      className={`rl-logo rl-logo--${variant} rl-logo--${theme} rl-logo--${size}${className ? ` ${className}` : ""}`}
    >
      <RemboMark size={markSize} variant="solid" />
      <span className="rl-logo-word">
        RemboList<span className="rl-logo-dot">.</span>
      </span>
    </span>
  );
}
